<template>
  <v-navigation-drawer v-model="$store.state.settings.sidenavOpen" app clipped>
    <v-list dense nav>
      <template v-for="(item, i) in displayedItems">
        <v-subheader v-if="item.heading" :key="i" class="text-subtitle-2">
          {{ item.heading }}
        </v-subheader>

        <v-divider v-else-if="item.divider" :key="i" class="my-2" />

        <v-list-item
          v-else
          :key="i"
          :disabled="!item.routeName"
          :to="{ name: item.routeName, query: item.query || {} }"
          active-class="primary--text"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t(item.text) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-list-item link @click="logout">
        <v-list-item-icon>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('logout') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <div class="d-flex align-center justify-center py-4 border-t">
        <span class="mr-2 text-subtitle-2"> {{ $t('developed_by') }}: </span>
        <a :href="$t('evolco_url')" class="d-flex" target="_blank">
          <img src="../assets/logo-dark.png" alt="" height="20" />
        </a>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NavigationDrawer',

  computed: {
    ...mapState('activityReports', ['activityReportsFilterParams']),
    ...mapState('awards', ['awardsFilterParams']),
    ...mapState('contacts', ['contactFilterParams']),
    ...mapState('patientStory', ['patientStoryFilterParams']),
    ...mapState('articles', ['articleFilterParams']),
    ...mapState('publications', ['publicationFilterParams']),
    ...mapState('users', ['userFilterParams']),
    ...mapState('popupBanners', ['popupBannerFilterParams']),

    items() {
      return [
        {
          icon: 'mdi-file-chart',
          text: 'activity_reports',
          routeName: 'activityReports',
          allowedRoles: ['admin'],
          query: this.activityReportsFilterParams,
        },
        {
          icon: 'mdi-medal',
          text: 'awards',
          routeName: 'awards',
          allowedRoles: ['admin'],
          query: this.awardsFilterParams,
        },
        {
          icon: 'mdi-book-open',
          text: 'contacts',
          routeName: 'contacts',
          allowedRoles: ['admin'],
          query: this.contactFilterParams,
        },
        {
          icon: 'mdi-calendar-alert',
          text: 'articles',
          routeName: 'articles',
          allowedRoles: ['admin'],
          query: this.articleFilterParams,
        },
        {
          icon: 'mdi-tag-multiple',
          text: 'metatags',
          routeName: 'metatags',
          allowedRoles: ['admin'],
          query: this.metatagFilterParams,
        },
        {
          icon: 'mdi-image-outline',
          text: 'upload-image',
          routeName: 'uploadImages',
          allowedRoles: ['admin'],
        },
        {
          icon: 'mdi-clipboard-text-outline',
          text: 'patient_story',
          routeName: 'patientStory',
          allowedRoles: ['admin'],
          query: this.patientStoryFilterParams,
        },
        {
          icon: 'mdi-animation',
          text: 'pages',
          routeName: 'pages',
          allowedRoles: ['admin'],
        },
        {
          icon: 'mdi-newspaper-variant-multiple-outline',
          text: 'publications',
          routeName: 'publications',
          allowedRoles: ['admin'],
          query: this.publicationFilterParams,
        },
        {
          icon: 'mdi-assistant',
          text: 'popup_banners',
          routeName: 'popupBanners',
          allowedRoles: ['admin'],
          query: this.popupBannerFilterParams,
        },
        {
          icon: 'mdi-account-multiple',
          text: 'users',
          routeName: 'users',
          allowedRoles: ['admin'],
          query: this.userFilterParams,
        },
        { divider: true, allowedRoles: ['admin'] },
        { icon: 'mdi-account', text: 'my_profile', routeName: 'profile' },
      ];
    },

    displayedItems() {
      return this.items.filter(
        (i) => !i.allowedRoles || i.allowedRoles.indexOf(this.currentUser.role) > -1,
      ); // eslint-disable-line max-len
    },

    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
  },

  methods: {
    logout() {
      this.$store.dispatch('auth/logout');
    },
  },
};
</script>
